import { render, staticRenderFns } from "./AddSuggestGoods.vue?vue&type=template&id=1ef63b1c&scoped=true&"
import script from "./AddSuggestGoods.vue?vue&type=script&lang=js&"
export * from "./AddSuggestGoods.vue?vue&type=script&lang=js&"
import style0 from "./AddSuggestGoods.vue?vue&type=style&index=0&id=1ef63b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef63b1c",
  null
  
)

export default component.exports